import { Component, Watch } from "vue-property-decorator";
import Header from "@/components/BaseCurd/header";
import TreeExpand from "@/components/TreeExpand/index.vue";
import { unFlatTreeData } from "@/components/RenderUtils/utils";
import renderUtils from "@/components/RenderUtils";
import MergeHooks from "@/decorators/mergeHooks";
import { getUserInfo } from "@/utils/auth";
import { MasterlinkTenantServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { WorkStationGroupServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
const wsgsp = new WorkStationGroupServiceProxy();
const mtsp = new MasterlinkTenantServiceProxy();
import "./index.less";
enum Codes {
  空,
  机器,
  人工,
}

@Component({
  TreeExpand,
  Header,
})
@MergeHooks
export default class WorkstationGroup extends renderUtils {
  get headerConfig() {
    return {
      left: {
        buttons: [
          {
            value: this.$t("page_workstation_group_add"),
            props: {
              type: "primary",
            },
            on: {
              click: this.openAddModal,
            },
            // directives: [
            //   {
            //     name: "acl",
            //     value: ACLS.ADD_RELATE,
            //   },
            // ],
          },
        ],
      },
    };
  }

  treeProps = {
    checkable: false,
    showIcon: true,
    showLine: false,
    defaultSelectedKeys: ["0"],
    treeData: [],
  };
  sourceData = [];
  addDataSource = [];
  selectedRowKeys = [];
  tableData = [];
  renameLeaf = null;
  visible = false;
  inputValue = "";
  parentId = "";
  selectId = null;
  showAddModal = false;
  tenantName = "";

  get menus() {
    const buttons = this.$store.getters.buttons;
    if (!buttons.includes("page_workstation_group_menu")) {
      return [];
    }
    const menus = [
      {
        // acl: "page_docdirectory_append",
        title: "page_docdirectory_add_submenu",
        on: {
          click: this.addMenu,
        },
      },
      {
        // acl: "page_docdirectory_rename",
        title: "page_docdirectory_rename",
        on: {
          click: this.renameMenu,
        },
      },
      {
        // acl: "page_docdirectory_delete",
        title: "delete",
        on: {
          click: this.deleteMenu,
        },
      },
    ];
    return menus;
    // return menus.filter((item) => buttons.includes(item.acl));
  }

  render() {
    return (
      <a-layout style="height: 100%">
        <a-layout-sider
          width="260"
          style="background: transparent;"
          class="no-fix-sider"
        >
          {/* <div style="height:32px;margin-bottom:8px;display:flex;justify-content:space-between">
            <span>{this.$t("page_workstation_maintain_station_group")}</span>
            <a-button type="primary" onClick={() => this.addMenu({ key: "0" })}>
              {this.$t("page_workstation_group_root_add")}
            </a-button>
          </div> */}
          <tree-expand
            style="height:100%;background:#fff;overflow:auto"
            ref="tree"
            treeProps={this.treeProps}
            menus={this.menus}
            onRename={this.updateMenu}
            treeEvents={{ select: this.handleSelect }}
          ></tree-expand>
        </a-layout-sider>
        <div v-resize={"x"}></div>
        <a-layout-content style={{ height: "100%", overFlowY: "auto" }}>
          <div style="height:100%">
            {/* <Header config={this.headerConfig} /> */}
            <div style="background: #fff;height:100%;">
              {this.renderWorkstationTable()}
              <a-button
                style="margin-top:8px"
                onClick={this.openAddModal}
                type="primary"
                block
                v-acl="page_workstation_group_add"
              >
                {this.$t("page_workstation_group_add")}
              </a-button>
            </div>
          </div>
        </a-layout-content>
        {this.renderModal()}
        {this.rrenderAddModal()}
      </a-layout>
    );
  }

  renderWorkstationTable() {
    const props = {
      rowKey: "index",
      canFixedHead: false,
      dataSource: this.tableData,
      columns: [
        {
          title: this.$t("page_workstation_group_name"),
          dataIndex: "name",
          // width: 300,
        },
        {
          title: this.$t("page_workstation_group_belong"),
          dataIndex: "groupId",
          customRender: (id) => {
            const find = this.sourceData.find((item) => item.id == id);
            return (find && find.name) || this.tenantName;
          },
        },
        // {
        //   title: this.$t("page_workstation_create_time"),
        //   dataIndex: "creatTime",
        // },
      ],
      actions: {
        del: {
          action: this.deleteWorkstation,
          acl: "page_workstation_group_delete",
          style:{color:"#ff4d4f"}
        },
      },
    };
    return this.renderTable(props);
  }

  renderModal() {
    return (
      <a-modal
        title={this.$t("page_docdirectory_add_submenu")}
        cancelText={this.$t("cancel")}
        okText={this.$t("save")}
        visible={this.visible}
        maskClosable={false}
        onOk={this.saveMenu}
        onCancel={() => (this.visible = false)}
      >
        <div class="modal-content">
          <span>{this.$t("page_docdirectory_name")}:</span>
          <a-input v-model={this.inputValue} maxLength={30}></a-input>
        </div>
      </a-modal>
    );
  }

  rrenderAddModal() {
    const columns = [
      {
        title: this.$t("page_workstation_code"),
        dataIndex: "code",
      },
      {
        title: this.$t("page_workstation_name"),
        dataIndex: "name",
        width:'150'
      },
      {
        title: this.$t("page_workstation_type"),
        dataIndex: "type",
        customRender: (text) => Codes[text],
        width:'80'
      },
    ];
    const props = {
      bodyStyle: {
        background: "#fff",
        overflowY: "auto",
        maxHeight: "600px",
        width:"100%"
      },
      canFixedHead: false,
      show: this.showAddModal,
      cancel: () => ((this.showAddModal = false), (this.selectedRowKeys = [])),
      title: this.$t("page_workstation_group_add"),
      columns: columns,
      dataSource: this.addDataSource,
      rowSelection: {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (value) => (this.selectedRowKeys = value),
      },
      footer: "default",
      ok: this.saveAdds,
    };
    return this.renderDialogWithTable(props);
  }
  async openAddModal() {
    this.addDataSource = await wsgsp.workStationList(this.selectId);
    this.showAddModal = true;
  }

  async created() {
    const qr = mtsp.queryRole(getUserInfo().tenant_id);
    const {
      data: { tenantName },
    } = await qr;
    this.tenantName = tenantName;
    this.getTree(true);
  }

  reset() {
    this.selectId = null;
    this.tableData = [];
  }

  async handleSelect([id]) {
    this.selectId = id;
  }

  async getTree(first = false) {
    const { workStationGroupDTOList: data } = await wsgsp.list();
    const treeData = unFlatTreeData()(data, (item) => ({
      title: item.name,
      key: item.id,
      scopedSlots: { title: "custom" },
    }));
    this.sourceData = data as any;
    this.treeProps.treeData = [
      {
        id: "0",
        key: "0",
        title: this.tenantName,
        scopedSlots: { title: "custom" },
        excludes: [this.$t("page_docdirectory_rename"), this.$t("delete")],
        children: treeData,
      },
    ];

    if (first) {
      // if (!treeData.length) {
      //   return this.reset();
      // }
      const select = "0";
      this.treeProps.defaultSelectedKeys = [select];
      this.selectId = select;
    } else {
      this.treeProps.defaultSelectedKeys = [this.selectId];
    }
  }

  @Watch("selectId", { immediate: true })
  async getData(value) {
    if (!value) return;
    const { records } = await wsgsp.workStationPage(1, value, -1);
    this.tableData = records;
  }

  showMenus() {}

  addMenu(context) {
    this.parentId = context.key;
    this.inputValue = "";
    this.visible = true;
  }
  renameMenu(context) {
    this.renameLeaf = context.key;
    (this.$refs.tree as any).onRename(context);
  }

  async updateMenu(value) {
    const find = this.sourceData.find((v) => v.id === this.renameLeaf);
    await wsgsp.update(find.id, value);
    this.$message.success(this.$t("page_docdirectory_edit_success"));
    this.getTree();
  }

  async deleteMenu(context) {
    await wsgsp.deleteWordStationById(context.key);
    this.$message.success(this.$t("page_docdirectory_delete_success"));
    this.getTree(true);
  }

  async saveMenu() {
    if (!this.inputValue)
      return this.$message.error(this.$t("page_docdirectory_name_empty") + "!");
    await wsgsp.saveWorkStation(this.inputValue, this.parentId);
    this.$message.success(this.$t("page_docdirectory_create_success"));
    this.visible = false;
    this.getTree();
  }

  async deleteWorkstation({ workStationId, groupId }) {
    await wsgsp.removeWorkStation(groupId, workStationId);
    this.$message.success(this.$t("page_docdirectory_delete_success"));
    this.getData(this.selectId);
  }

  async saveAdds() {
    if (!this.selectedRowKeys.length) return;

    await wsgsp.saveWorkStationToGroup({
      groupId: this.selectId,
      workStationId: this.selectedRowKeys,
    } as any);
    this.$message.success(this.$t("save_success"));
    this.showAddModal = false;
    this.selectedRowKeys = [];
    this.getData(this.selectId);
  }
}
